module.exports = __webpack_public_path__ + "img/mikko.5458605.png";